export enum RelocationEquipmentApiEnum {
  GetRelocationEquipmentAttachmentList = '/relocation-equipments/:id/attachments',
  GetTechnicalExamination = '/relocation-equipments/:id/technical-examinations',
  CreateTechnicalExamination = '/relocation-equipments/:id/technical-examinations',
}

export enum RelocationEquipmentApiTagEnum {
  RelocationEquipmentAttachmentList = 'RelocationEquipmentAttachmentList',
}
